export default "__VITE_PUBLIC_ASSET__4bb091fd__"